import { initializeGrid } from "./base"

if (document.querySelectorAll(".payees-show").length) {
  initializeGrid({
    gridName: "payable_systems",
    sizeColumnsToFit: true, autoSizeStrategy: {
      defaultMinWidth: 100,
      type: "fitGridWidth"
    }})
}
